export function formatHour(hms) {
  if (!hms) return '';
  const [h, m] = hms.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 === 0 ? 12 : h % 12;
  return m === 0 ? `${hour} ${period}` : `${hour}:${String(m).padStart(2, '0')} ${period}`;
}

export function durationMins(startHms, endHms) {
  if (!startHms || !endHms) return 0;
  const [sh, sm] = startHms.split(':').map(Number);
  const [eh, em] = endHms.split(':').map(Number);
  let mins = (eh * 60 + em) - (sh * 60 + sm);
  if (mins <= 0) mins += 24 * 60;
  return mins;
}

export function formatDuration(mins) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

export function formatChip(startHms, endHms) {
  if (!startHms || !endHms) return '';
  const mins = durationMins(startHms, endHms);
  return `${formatHour(startHms)} – ${formatHour(endHms)} · ${formatDuration(mins)}`;
}
